import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Response } from "../models/response";
import HttpClient from "../utils/network";
import { OnSiteApi } from "../apis/onsite";
import { CacheKey } from "../models/cacheKey";

export function useCheckInMemo({
  eventId,
  rewardId,
  checkInId,
}: {
  eventId?: number;
  rewardId?: number;
  checkInId?: number;
}) {
  const queryClient = useQueryClient();

  const { mutateAsync: postMemo, isPending } = useMutation({
    mutationFn: async ({ memo }: { memo: string }) => {
      if (eventId && rewardId && checkInId) {
        const response = new Response(
          await HttpClient.request(
            OnSiteApi.postMemo(eventId, rewardId, checkInId, memo),
          ),
        );
        if (response.status < 300) {
          await queryClient.invalidateQueries({
            queryKey: [CacheKey.getCheckInDetail, eventId],
          });
        }
      }
      return null;
    },
  });

  return { postMemo, isPending };
}
